import { atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import {
  GiftOrderForAdmin,
  GiftOrderForStore,
  GiftOrderListForAdmin,
  GiftOrderListForStore,
} from './giftOrder.interface';

// Admin용 GiftOrder 목록 (결제완료)
export const giftOrderListForAdminStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftOrderListForAdminStatusAtomFamily',
  default: 'idle',
});

export const giftOrderListForAdminDataAtomFamily = atomFamily<
  GiftOrderListForAdmin | null,
  string
>({
  key: 'giftOrderListForAdminDataAtomFamily',
  default: null,
});

// Admin용 GiftOrder 검색 결과
export const giftOrderSearchStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftOrderSearchStatusAtomFamily',
  default: 'idle',
});

export const giftOrderSearchDataAtomFamily = atomFamily<
  GiftOrderListForAdmin | null,
  string
>({
  key: 'giftOrderSearchDataAtomFamily',
  default: null,
});

// Admin용 단일 GiftOrder
export const giftOrderForAdminStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftOrderForAdminStatusAtomFamily',
  default: 'idle',
});

export const giftOrderForAdminDataAtomFamily = atomFamily<
  GiftOrderForAdmin | null,
  string
>({
  key: 'giftOrderForAdminDataAtomFamily',
  default: null,
});

// Store용 GiftOrder 목록 (본인 주문)
export const giftOrderListForStoreStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftOrderListForStoreStatusAtomFamily',
  default: 'idle',
});

export const giftOrderListForStoreDataAtomFamily = atomFamily<
  GiftOrderListForStore | null,
  string
>({
  key: 'giftOrderListForStoreDataAtomFamily',
  default: null,
});

// Store용 단일 GiftOrder
export const giftOrderForStoreStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftOrderForStoreStatusAtomFamily',
  default: 'idle',
});

export const giftOrderForStoreDataAtomFamily = atomFamily<
  GiftOrderForStore | null,
  string
>({
  key: 'giftOrderForStoreDataAtomFamily',
  default: null,
});
